import { toast } from "react-toastify";
import { api } from "../utils/axios";
import {
	RECEIVE_USER_ERROR,
	RECEIVE_USER_RESPONSE,
	SEND_USER_REQUEST,
	SET_IS_LOGIN,
} from "./ActionTypes";

export const sendUserRequest = () => {
	return {
		type: SEND_USER_REQUEST,
	};
};
export const receiveUserResponse = (data) => {
	return {
		type: RECEIVE_USER_RESPONSE,
		payload: data,
	};
};
export const receiveUserError = (data) => {
	return {
		type: RECEIVE_USER_ERROR,
		payload: data,
	};
};

// New action to update a specific user's manager status
export const updateUserManagerStatus = (userId, isLeader) => {
	return {
		type: "UPDATE_USER_MANAGER_STATUS",
		payload: { userId, isLeader },
	};
};

export const getAllUserInfo = () => {
	return async (dispatch) => {
		dispatch(sendUserRequest());

		const token = localStorage.getItem("token");
		if (!token) {
			dispatch(receiveUserError("No token found"));
			toast.error("توکنی یافت نشد");
			return;
		}

		try {
			const res = await api.get("/home", {
				headers: { Authorization: `Bearer ${token}` },
			});

			dispatch(receiveUserResponse(res.data));
		} catch (err) {
			const status = err?.response?.status;
			const message = err?.response?.data?.error || err?.message;

			// 401: auth problem (token invalid/expired/missing)
			if (status === 401) {
				localStorage.removeItem("token");
				dispatch(receiveUserError(message));
				toast.error("نشست شما منقضی شده. دوباره وارد شوید.");
				// navigate to login (pick one approach)
				window.location.href = "/login";
				return;
			}

			// 403: subscription problem (expired / no active subscription)
			if (status === 403) {
				dispatch(receiveUserError(message));
				toast.error("اشتراک شما فعال نیست. لطفاً اشتراک تهیه کنید.");

				if (window.location.pathname !== "/subscriptions") {
					window.location.href = "/subscriptions";
				}
				return;
			}

			dispatch(receiveUserError(message));
			toast.error("خطا در دریافت اطلاعات کاربر");
		}
	};
};

// src/Store/UserAction.js

export const userLogout = () => async (dispatch) => {
	try {
		// 1. Tell Backend to clear the cookie
		await api.post("/logout");

		// 2. ✅ CRITICAL: Kill Matrix Connection immediately
		// We can't access 'client' here directly, but clearing storage helps.
		// The real kill happens because we force a window reload or state change.
		localStorage.removeItem("matrix_config");
		localStorage.removeItem("token");

		// 3. Clear Redux Data
		dispatch({ type: "USER_LOGOUT" });

		// 4. Force Reload (Optional but safest)
		// This instantly kills all WebSockets and Sync loops
		window.location.href = "/login";
	} catch (error) {
		console.error("Logout failed", error);
	}
};
